/** Protected nulls mean withheld data, rather than an empty or zero value. */
export function isProtectedField(name: string): boolean {
  return ['bankblock', 'banksnapshot', 'buyername', 'itemamount'].includes(
    name.replace(/[ _]/g, '').toLowerCase()
  );
}

export function isBankField(name: string): boolean {
  return ['bankblock', 'banksnapshot'].includes(name.replace(/[ _]/g, '').toLowerCase());
}
